function StatisticsIndicatorMeta($container, opt_opts){
	opt_opts = opt_opts || {};
	var that = this;
	that.options = opt_opts;
	this.url = opt_opts.url||"/statistics";
	this.standaloneMetabox = opt_opts.standaloneMetabox || false;
	this.that = this;
	this.xhr = null;
	this.$container = $container;
	this.$metaBox = $('<div class="popup-box meta-box"><div class="arrow"></div><div class="preloader"><em class="fa fa-cog fa-spin fa-3x fa-fw"></em></div><div class="meta-c"></div></div>');
	this.$chartBox = $container.find('.chart-box')
	this.tableId = this.$container.data("table");
	this.loadMetaDataTimeout = 0;
	this.$currentMetaInfo = null;
	this.$currentChartInfo = null;
	this.$iMng = null;
	this.$container.append(this.$metaBox);
	this.$statsetsAddAllBtn = $container.find('a.add-to-ss-check-all');



	this.$container.on("click", ".add-to-ss", function(e){
		e.preventDefault();
		that.statsetsAddOne($(this))
	});

	this.$container.on("click", ".check-tgl", function(e){
		e.preventDefault();
		that.toggleCheck($(this))
	});
	this.$statsetsAddAllBtn.on('click', function (e) {
		e.preventDefault();
		that.statsetsAddAll()
	})

	this.$container.on("click", ".meta-info", function(e){
		e.preventDefault();
		that.toggleMetaBox($(this))
	});

	this.$container.on("click", ".toggle-dim-children", function(e){
		e.preventDefault();
		that.toggleDimChildren($(this))
	});

	this.$container.on("click", ".chart-info", function(e){
		e.preventDefault();
		that.toggleChartBox($(this));
	});

	this.$container.on("click", ".i-mng-toggle", function(e){
		e.preventDefault();
		that.toggleActions($(this).parent());
	});
	this.$chartBox.find('button.chart-type').on('click', function (e) {
		e.preventDefault()
		that.toggleChartType($(this))
		that.saveChartSettings()
	})


	this.$chartBox.find('button.a-save').on('click', function (e) {
		e.preventDefault()
		that.saveChartSettings()
	})
	this.$chartBox.find('button.a-clear').on('click', function (e) {
		e.preventDefault()
		that.clearChartSettings()
	})
}
StatisticsIndicatorMeta.prototype.startListeningGlobalBodyClick = function(){
	var that = this;
	setTimeout(function () {
		$('body')
			.data("statsMetaInstance", that)
			.on("click", that.onBodyClick);
	}, 20)
}
StatisticsIndicatorMeta.prototype.stopListeningGlobalBodyClick = function(){
	var that = this;
	$('body').off("click", that.onBodyClick);
}
StatisticsIndicatorMeta.prototype.onBodyClick = function(e){
	var $body = $(this);
	var that = $body.data('statsMetaInstance');
	var $clickTarget = $(e.target);

	if(
		$clickTarget.parents(".i-mng").length == 0
		&& $clickTarget.parents(".meta-box").length == 0
		&& $clickTarget.parents(".chart-box").length == 0
		&& !$clickTarget.hasClass("meta-box")
	){
		if(that.$iMng){
			that.$iMng.removeClass('active');
			that.$iMng = null;
		}
		that.closeMetaBox();
		that.closeChartBox();
		that.stopListeningGlobalBodyClick();
	}
}

StatisticsIndicatorMeta.prototype.toggleActions = function ($iMng) {
	var that = this;
	that.closeMetaBox();
	that.closeChartBox();
	that.stopListeningGlobalBodyClick();

	if(that.$iMng && !that.$iMng.is($iMng)){
		that.$iMng.removeClass('active');
	}

	if($iMng.hasClass('active')){
		$iMng.removeClass('active');
	}else{
		$iMng.find('.i-mng-actions').width($iMng.find('.i-mng-actions > *').length * 30)
		$iMng.addClass('active');
		that.startListeningGlobalBodyClick()
	}
	that.$iMng = $iMng;
}
StatisticsIndicatorMeta.prototype.toggleChartBox = function ($target) {
	var that = this;
	that.closeMetaBox()
	if($target.hasClass("active")) {
		that.closeChartBox();
	}else{
		that.openChartBox($target);
	}
}
StatisticsIndicatorMeta.prototype.toggleMetaBox = function ($target) {
	var that = this;
	that.closeChartBox()
	if($target.hasClass("active")) {
		that.closeMetaBox();
	}else{
		if(this.standaloneMetabox) that.stopListeningGlobalBodyClick();
		clearTimeout(that.loadMetaDataTimeout);
		that.loadMetaDataTimeout = setTimeout(function(){
			that.loadMetaData($target);
		}, 100);
		if(this.standaloneMetabox) that.startListeningGlobalBodyClick();
	}
}

StatisticsIndicatorMeta.prototype.toggleDimChildren = function ($target) {
	var that = this;

	var $filterForm = this.$container.find('.filter_form');

	var dims = $target.data('dim').split(',');
	var dimValues = $target.data('dim-values').split(',');

	dims.forEach(function (dim){
		var $input = $filterForm.find('[name="'+dim+'[]"]');
		var currentValues = $input.val();




		var isChildrenDimValuesExpanded = false;

		dimValues.forEach(function (dimValue){
			var index = currentValues.indexOf(dimValue);

			if(index >= 0){
				isChildrenDimValuesExpanded = true;
			}
		})

		if(isChildrenDimValuesExpanded){
			dimValues.forEach(function (dimValue){
				var index = currentValues.indexOf(dimValue);
				if(index >= 0){
					currentValues.splice(index, 1);
				}
			})
		}else{
			dimValues.forEach(function (dimValue){
				var index = currentValues.indexOf(dimValue);
				if(index < 0){
					currentValues.push(dimValue)
				}
			})
		}


		$input.val(currentValues).change();
	})
}

StatisticsIndicatorMeta.prototype.loadMetaData = function($target){
	var that = this;
	var $target = $target;
	that.$metaBox.find(".preloader").show();
	that.$metaBox.find(".meta-c").html('');
	that.positionBox($target, that.$metaBox);
	if(that.xhr != null){
		that.xhr.abort();
	}

	var reqData = {
		table_id: $target.data("table")?$target.data("table"):this.tableId,
		code: $target.data("code")
	}
	if($target.data('tablerow')){
		reqData.tablerow = $target.data('tablerow');
	}

	var url = that.url + "/indicator_meta";
	if($target.data("url")){
		url = $target.data("url");
	}

	that.xhr = $.ajax({
		url: url,
		data: reqData,
		success: function (response) {
			that.$metaBox.find(".preloader").hide();
			that.$metaBox.find(".meta-c").html(response);
			that.positionBox($target, that.$metaBox);
			that.xhr = null;

			if(typeof that.options.after_meta_show == 'function'){
				that.options.after_meta_show(that.$metaBox);
			}
		}
	});
	if(!that.$currentMetaInfo){
		that.$currentMetaInfo = $target;
		that.$currentMetaInfo.addClass("active");
		/*
		$('body').data("currentMetaBox", that);
		$('body').on("click", that.onBodyClick);
		*/
	}
}
StatisticsIndicatorMeta.prototype.positionBox = function($target, $box){
	$box.removeClass("left-arrow right-arrow");

	var $metaBoxArrow = $box.find(".arrow");
	//var $metaBoxActiveArea = $box.find(".active-area");

	//$metaBoxActiveArea.css("top", 15);

	var top = $target.offset().top - this.$container.offset().top - 40;

	if($target.offset().top + $box.outerHeight() > document.body.clientHeight){
		//var offset = document.body.clientHeight - $target.offset().top - this.$metaBox.outerHeight();
		//top += offset;
		//$metaBoxArrow.css("top", 30 - offset);
		//$metaBoxActiveArea.css("top", 15 - offset);

		// var offset = -document.body.clientHeight * 0.3;
		// top += offset;
		// $metaBoxArrow.css("top", 30 - offset);
	}

	if(window.innerWidth < 600){
		$box.css({
			top: top+80,
		}).show().addClass("top-arrow");
		$metaBoxArrow.css({
			left: $target.offset().left - $box.offset().left - 7
		});
	} else if($target.offset().left + 100 + $box.outerWidth() < window.innerWidth){
		$box.css({
			left: $target.offset().left - this.$container.offset().left + 40,
			top: top
		}).show().addClass("left-arrow");
	}else{
		$box.css({
			left: $target.offset().left - this.$container.offset().left - 40 - $box.outerWidth(),
			top: top
		}).show().addClass("right-arrow");
	}

}
StatisticsIndicatorMeta.prototype.closeMetaBox = function(){
	var that = this;
	if(that.$currentMetaInfo){
		that.$currentMetaInfo.removeClass("active");
		that.$currentMetaInfo = null;
		that.$metaBox.hide();

		if(typeof that.options.after_meta_close == 'function'){
			that.options.after_meta_close(that.$metaBox);
		}
	}
}
StatisticsIndicatorMeta.prototype.openChartBox = function($target){
	var that = this;
	that.$currentChartInfo = $target;
	that.$currentChartInfo.addClass('active')
	that.positionBox($target, that.$chartBox)
	that.$chartBox.show();

	var chartInstance = that.$container.data('chartInstance');

	that.$chartBox.find('.chart-panel').each(function () {
		var $panel = $(this);
		$(this).find('.chart-type').each(function () {
			var $type = $(this);
			var indicator = chartInstance.findIndicator(
				$target.data('id'),
				$target.data('code'),
				$panel.data('id'),
				$type.data('id')
			);
			if(indicator){
				$type
					.addClass('active')
					.data('chart-indicator', indicator)
			}else{
				$type.removeClass('active')
			}
		})
	})
}
StatisticsIndicatorMeta.prototype.closeChartBox = function(){
	var that = this;
	if(that.$currentChartInfo){
		that.$currentChartInfo.removeClass("active");
		that.$currentChartInfo = null;
		that.$chartBox.hide();
	}
}

StatisticsIndicatorMeta.prototype.toggleChartType = function($chartTypeBtn){
	var that = this;
	$chartTypeBtn.toggleClass('active');
}
StatisticsIndicatorMeta.prototype.clearChartSettings = function(){
	var that = this;
	that.$chartBox.find('.chart-panel > .chart-type').removeClass('active');
	that.saveChartSettings();
}
StatisticsIndicatorMeta.prototype.saveChartSettings = function(){
	var that = this;

	var id = that.$currentChartInfo.data('id');
	var code = that.$currentChartInfo.data('code');
	var chartInstance = that.$container.data('chartInstance');
	var isDirty = false;

	that.$chartBox.find('.chart-panel').each(function () {
		var $panel = $(this);
		$(this).find('.chart-type').each(function () {
			var $type = $(this);

			var indicator = chartInstance.findIndicator(id, code, $panel.data('id'), $type.data('id'));

			if($type.hasClass('active')){
				if(!indicator){
					chartInstance.addIndicator(id, code, $panel.data('id'), $type.data('id'))
					isDirty = true;
				}
			}else{
				if(indicator){
					chartInstance.removeIndicator(indicator)
					isDirty = true;
				}
			}
		})
	});
	if(isDirty){
		chartInstance.reloadChartData();
	}
	that.closeChartBox();
};
StatisticsIndicatorMeta.prototype.toggleCheck = function($target){
	var that = this;
	$target.toggleClass('checked')
	if(that.$container.find('.check-tgl.checked').length){
		that.$statsetsAddAllBtn.removeClass("hidden")
	}else{
		that.$statsetsAddAllBtn.addClass("hidden")
	}

	var $statusWrap = $target.parents('th').find('.i-status');
	if($target.hasClass("checked")){
		if($statusWrap.find('.fa.fa-check').length == 0) {
			$statusWrap.prepend('<em class="fa fa-check"></em>');
		}
	}else{
		$statusWrap.find(".fa.fa-check").remove();
	}
};


module.exports = StatisticsIndicatorMeta;